import React, { useState } from 'react';
import { Input, Button, Select, Dropdown, MenuProps } from 'antd';

import './PageScaffoldControls.css';

interface ActionButton {
  label: string | React.ReactNode;
  type?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
  props?: React.ComponentProps<typeof Button>;
  buttonType?: string;
  items?: MenuProps['items'] | undefined;
}

interface PageScaffoldControlsProps {
  countryAddonBefore?: boolean;
  searchLabel: string;
  onSearch: (input: string, addonBeforeQuery: string) => void;
  isLoading: boolean;
  onSearchCancel: () => void;
  hideSearch?: boolean;
  actionButtons: ActionButton[];
  searchInputs?: (inputs: React.ReactNode) => React.ReactNode;
  filterSettings?: {
    placeholder?: string;
    onFilter: (filter: string) => void;
    values: {
      label: string;
      value: string;
    }[];
    selectedValue: string | undefined | null;
    clearable?: boolean;
  };
}

const PageScaffoldControls: React.FC<PageScaffoldControlsProps> = ({
  countryAddonBefore,
  searchLabel,
  onSearch,
  isLoading,
  onSearchCancel,
  hideSearch,
  actionButtons,
  searchInputs,
  filterSettings
}) => {
  const [searchInput, setSearchInput] = useState<string>('');
  const [selectedCountry, setSelectedCountry] = useState<string>('33600000000');

  const handleSearch = () => {
    if (searchInput.length > 0) {
      onSearch(searchInput, selectedCountry);
    }
  };

  const getSearchInputs = () => {
    return <Input.Search
      addonBefore={
        countryAddonBefore && (
          <Select
            value={selectedCountry}
            onChange={(value) => setSelectedCountry(value)}
          >
            <Select.Option value="33600000000">
              <span role="img" aria-label="France">
                🇫🇷
              </span>
            </Select.Option>
            <Select.Option value="32400000000">
              <span role="img" aria-label="Belgium">
                🇧🇪
              </span>
            </Select.Option>
            <Select.Option value="41700000000">
              <span role="img" aria-label="Switzerland">
                🇨🇭
              </span>
            </Select.Option>
          </Select>
        )
      }
      placeholder={searchLabel}
      value={searchInput}
      style={{ width: 306 }}
      onChange={(e) => {
        setSearchInput(e.target.value);
        if (e.target.value === '') {
          onSearchCancel();
        }
      }}
      onSearch={handleSearch}
      loading={isLoading}
    />
  }

  return (
    <div className="page-scaffold-controls">
      <div className="page-scaffold-controls__inputs">
        {!hideSearch && (
          (searchInputs ? searchInputs(getSearchInputs()) : getSearchInputs())
        )}
        {filterSettings && (
          <div className="page-scaffold-controls__inputs__input">
            <Select
              placeholder={filterSettings?.placeholder ?? ''}
              disabled={isLoading}
              allowClear={filterSettings?.clearable ?? false}
              onChange={(value) => {
                filterSettings?.onFilter(value);
              }}
              value={filterSettings?.selectedValue}
              style={{ width: '100%' }}
            >
              {filterSettings?.values.map((valItem) => (
                <Select.Option key={valItem.value} value={valItem.value}>
                  {valItem.label}
                </Select.Option>
              ))}
            </Select>
          </div>
        )}
      </div>
      <div className="page-scaffold-controls__action-buttons">
        {actionButtons.map((btn, index) => (
          btn.buttonType === 'dropdown' ?
            <Dropdown key={index} menu={{ items: btn.items }} placement="bottomRight" arrow={{ pointAtCenter: true }}>
              <Button {...btn.props} type={btn.type}>{btn.label}</Button>
            </Dropdown> :
            <Button key={index} {...btn.props} type={btn.type}>
              {btn.label}
            </Button>
        ))}
      </div>
    </div>
  );
};

export default PageScaffoldControls;
